__turbopack_context__.v({
  "muted": "tones-module__NytYxq__muted",
  "strong": "tones-module__NytYxq__strong",
});
